import { withDependencies } from '@wix/thunderbolt-ioc'
import { BatchingStrategy, BatchingStrategySymbol, ILogger, LoggerSymbol } from '@wix/thunderbolt-symbols'
import type { IViewerBatchingManager } from './types'

class ViewerBatchingManagerError extends Error {
	constructor(message: string) {
		super(message)
		this.name = 'ViewerBatchingManagerError' // for grouping the errors in the rollout grafana
	}
}

export const ViewerBatchingManager = withDependencies(
	[BatchingStrategySymbol, LoggerSymbol],
	(batchingStrategy: BatchingStrategy, logger: ILogger): IViewerBatchingManager => {
		const renderBlockingTasks: Array<Promise<void>> = []
		let isDuringBatchAsync = false
		// waitForAll differ from promise.all by the ability to wait for changing array.
		const waitForAll = async (): Promise<void> => {
			if (!renderBlockingTasks.length) {
				isDuringBatchAsync = false
				return
			}

			try {
				await renderBlockingTasks.shift()
			} catch (e) {
				logger.captureError(new ViewerBatchingManagerError('render blocking task failed'), {
					tags: {
						feature: 'viewer-batching-manager',
						methodName: 'addRenderBlockingTask',
						error: e.message,
						type: e.name,
					},
					extra: { error: e },
				})
			}

			return waitForAll()
		}
		return {
			addRenderBlockingTask: (promise) => {
				renderBlockingTasks.push(promise)
				if (!isDuringBatchAsync) {
					isDuringBatchAsync = true
					batchingStrategy.batchAsync(waitForAll())
				}
			},
		}
	}
)
